/**
 * Route for `agency-plan-unlock-multi-client-sub-admins-white-label-smartlink-manual-campaign-grouping`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingPage } from "../features/agency-plan-unlock-multi-client-sub-admins-white-label-smartlink-manual-campaign-grouping/AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingPage";

export const agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/agency-plan-unlock-multi-client-sub-admins-white-label-smartlink-manual-campaign-grouping",
	component: AgencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingPage,
});

export default agencyPlanUnlockMultiClientSubAdminsWhiteLabelSmartlinkManualCampaignGroupingRoute;
